// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2hakv","load8":"Spinner_load8__1FLaS"};